import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '~/shadcn/ui/table'
import { cn } from '~/shadcn/lib/utils'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'
import { DateTimeFormatter } from '~/@mid_ui/datetime-formatter/DateTimeFormatter'
import { Spinner } from '~/shadcn/ui/spinner'
import type { IAmbassadorClient } from '~/@api/generated-api-types-ambassador/Api'

type Props = {
  clients: Array<IAmbassadorClient>
  isLoading?: boolean
}

export function DetailTable({ clients, isLoading }: Props) {
  return (
    <div className="overflow-hidden">
      <Table>
        <TableHeader className="h-[34px]">
          <TableRow className="">
            <TableHead className="p-2 text-xs font-medium text-muted-foreground">
              MENO
            </TableHead>

            <TableHead className="p-2 text-xs font-medium text-muted-foreground">
              EMAIL
            </TableHead>

            <TableHead className="p-2 text-xs font-medium text-muted-foreground">
              INVESTOVAL
            </TableHead>

            <TableHead className="p-2 text-xs font-medium text-muted-foreground">
              VZNIK
            </TableHead>
          </TableRow>
        </TableHeader>

        <TableBody>
          {isLoading && (
            <TableRow>
              <TableCell colSpan={4} className="h-20 text-center">
                <Spinner className="size-6 mx-auto" />
              </TableCell>
            </TableRow>
          )}

          {!isLoading && clients.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={4}
                className="h-20 text-center text-sm font-medium text-muted">
                Žiadni klienti.
              </TableCell>
            </TableRow>
          )}

          {!isLoading &&
            clients.map((row, index) => (
              <TableRow
                key={`${row.email}-${index}`}
                className={cn(
                  'h-[45px]',
                  'text-sm font-medium',
                  '[&_td]:border-b [&_td]:border-muted-light',
                  'last:[&_td]:border-b-0'
                )}>
                <TableCell className="px-2">
                  <div className="flex items-center gap-2">
                    <span>{row.name}</span>
                  </div>
                </TableCell>

                <TableCell className="px-2">
                  <div className="flex">{row.email}</div>
                </TableCell>

                <TableCell className="px-2">
                  <CurrencyFormatter
                    value={row.investedSum}
                    className="text-base font-medium"
                    hideDecimal
                  />
                </TableCell>

                <TableCell className="px-2">
                  <DateTimeFormatter value={row.createdAt} />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  )
}
